import { render, staticRenderFns } from "./RiwayatAsetMiniCard.vue?vue&type=template&id=96f84b46"
import script from "./RiwayatAsetMiniCard.vue?vue&type=script&lang=js"
export * from "./RiwayatAsetMiniCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports